import { apiClient } from './client';
import { parseTitleSearch } from './title-search-contract';

export const titleSearchApi = {
  async search(query: string, kind: string) {
    return parseTitleSearch(await apiClient.titles.search({ q: query.trim(), kind, limit: 10 }));
  },
};
